import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { openPdfInTab } from "./printUtils";

pdfMake.vfs = pdfFonts.vfs;

const ReceiptPrint = (values, logoBase64, poojaMasterList, nakshatraMasterList, gotraMasterList, targetWindow = null) => {
    return new Promise((resolve, reject) => {
        try {
            const paymentTypes = {
                'CA': 'Cash',
                'CQ': 'Cheque',
                'DC': 'Credit/Debit Card',
                'RT': 'RTGS',
                'UP': 'UPI',
                'NB': 'Net Banking',
                'WL': 'Wallet',
                'Online': 'Online',
            }

            const poojaDetails = [];

            const {
                receiptNo = "NA",
                receiptDate,
                poojaType1,
                poojaType2,
                poojaDateTime1,
                poojaDateTime2,
                devoteeName,
                mobile,
                alternateMobile,
                gotra,
                nakshatra,
                poojaAmount = 0,
                jaThaPraPersons = 0,
                jaThaPraRate = 0,
                masterJaThaPraRate,
                extraRate = 0,
                extraRemarks = "",
                extraPersons = 0,
                paymentType,
                developmentCharges
            } = values || {};

            let formattedDate = '';
            if (receiptDate) {
                const receiptDateObj = new Date(receiptDate);
                if (!isNaN(receiptDateObj)) {
                    formattedDate = receiptDateObj.toLocaleDateString('en-GB').replace(/\//g, '-');
                }
            }

            const poojaTime = poojaMasterList.find((p) => p.poojaId?.toString() === poojaType1?.toString())?.poojaTime || "NA";

            const formatDate = (dateObj) =>
                dateObj ? new Date(dateObj).toLocaleDateString("en-IN", { day: '2-digit', month: 'short', year: 'numeric' }) : "";


            // Get gotra and nakshatra names
            const gotraName = gotraMasterList.find((g) => g.gotraId?.toString() === gotra?.toString())?.gotraName || "NA";
            const nakshatraName = nakshatraMasterList.find((n) => n.nakshatraId?.toString() === nakshatra?.toString())?.nakshatraName || "NA";


            // Fetch pooja rows from master list
            const addPoojaIfValid = (type, dateTime) => {
                const item = poojaMasterList.find((p) => p.poojaId?.toString() === type?.toString());
                if (item) {
                    poojaDetails.push({
                        slNo: poojaDetails.length + 1,
                        poojaName: item.poojaName,
                        date: formatDate(dateTime),
                        persons: item.noOfPersons,
                        rate: "",
                        amount: item.poojaAmount,
                    });
                }
            };

            addPoojaIfValid(poojaType1, poojaDateTime1);
            addPoojaIfValid(poojaType2, poojaDateTime2);

            if (jaThaPraPersons && jaThaPraRate) {
                poojaDetails.push({
                    slNo: poojaDetails.length + 1,
                    poojaName: "Additional Ja Tha Pra",
                    date: "",
                    persons: jaThaPraPersons,
                    rate: jaThaPraRate / jaThaPraPersons || 0,
                    amount: jaThaPraRate,
                });
            }

            if (extraRate || extraPersons) {
                poojaDetails.push({
                    slNo: poojaDetails.length + 1,
                    poojaName: "Extra Special Tha Pra",
                    date: "",
                    persons: extraPersons,
                    rate: "",
                    amount: extraRate + developmentCharges,
                });
            }


            const grandTotal = poojaDetails.reduce((sum, item) => sum + Number(item.amount || 0), 0);

            // Total persons
            const totalPersons = poojaDetails.reduce((sum, item) => sum + Number(item.persons || 0), 0);


            const tableBody = [
                [
                    { text: "Sl.No.", bold: true },
                    { text: "Pooja Name", bold: true },
                    { text: "Date", bold: true },
                    { text: "No.Of Persons", bold: true },
                    { text: "Rate", bold: true },
                    { text: "Amount", bold: true }
                ],
                ...poojaDetails.map(item => ([
                    item.slNo,
                    item.poojaName,
                    item.date,
                    item.persons,
                    item.rate ? `₹${item.rate}` : "",
                    item.amount ? `₹${item.amount}` : ""
                ])),
                [
                    { text: "", colSpan: 4 }, "", "", "", { text: `Grand Total :`, bold: true }, { text: `₹${grandTotal}`, bold: true }
                ]
            ];

            const docDefinition = {
                content: [
                    {
                        columns: [
                            {
                                image: 'templeLogo',
                                width: 500,
                                alignment: 'center',
                                margin: [0, 0, 0, 10]
                            },
                        ]
                    },
                    {
                        stack: [
                            { text: "Sri VENUGOPALA SWAMY TEMPLE (R)", bold: true, fontSize: 14, margin: [0, 2] },
                            { text: "Sri Raghavendra Swamy Temple", bold: true, fontSize: 12, margin: [0, 2] },
                            { text: "Old Airport Road, Near Hal Market, Vimanapura, Bangalore-17", style: 'small' },
                            { text: "Secretary: 9448512003, President: 9480809048", style: 'small' },
                        ],
                        alignment: 'center',
                        margin: [0, 0, 0, 15]
                    },
                    {
                        columns: [
                            { text: `Receipt Date: ${formattedDate}`, alignment: 'left', margin: [0, 0, 0, 5] },
                            { text: `Receipt No.: ${receiptNo}`, alignment: 'right', margin: [0, 0, 0, 5] }
                        ]
                    },
                    {
                        columns: [
                            { text: `Devotee Name: ${devoteeName}`, margin: [0, 0, 0, 5] },
                            { text: `Mobile No.: ${mobile}`, alignment: 'right', margin: [0, 0, 0, 5] }
                        ]
                    },
                    {
                        columns: [
                            { text: `Pooja: ${poojaDetails[0].date}`, margin: [0, 0, 0, 5] },
                            { text: `Nakshatra Name: ${nakshatraName}`, alignment: 'center', margin: [0, 0, 0, 5] },
                            { text: `Gotra Name: ${gotraName}`, alignment: 'right', margin: [0, 0, 0, 5] }
                        ]
                    },
                    {
                        columns: [
                            { text: `Pooja Time: ${poojaTime}` },
                            { text: `Total Persons: ${totalPersons}`, alignment: 'right' }
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        table: {
                            widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto'],
                            body: tableBody
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return 0.5;
                            },
                            vLineWidth: function (i, node) {
                                return 0.5;
                            },
                            hLineColor: function (i, node) {
                                return '#444';
                            },
                            vLineColor: function (i, node) {
                                return '#444';
                            },
                            paddingLeft: function (i, node) { return 5; },
                            paddingRight: function (i, node) { return 5; },
                            paddingTop: function (i, node) { return 3; },
                            paddingBottom: function (i, node) { return 3; },
                        },
                        margin: [0, 0, 0, 15]
                    },
                    {
                        columns: [
                            { text: `Payment : ${paymentTypes[paymentType] || paymentType || 'NA'}`, margin: [0, 0, 0, 10] },
                        ]
                    },
                    {
                        text: "Office Contact No - Srikanth Acharya : 9916077255, D S Suresh : 9448357701",
                        alignment: 'center',
                        style: 'small',
                        margin: [0, 0, 0, 0]
                    }
                ],
                images: {
                    templeLogo: logoBase64
                },
                styles: {
                    title: {
                        fontSize: 16,
                        bold: true,
                        alignment: 'center'
                    },
                    small: {
                        fontSize: 9,
                        lineHeight: 1.1
                    }
                },
                defaultStyle: {
                    fontSize: 10,
                    lineHeight: 1.2
                }
            };


            const pdfDoc = pdfMake.createPdf(docDefinition);
            openPdfInTab(pdfDoc, resolve, targetWindow);
        } catch (error) {
            console.error("Error in ReceiptPrint:", error);
            resolve({ success: false, error: error });
        }
    });
};

export default ReceiptPrint;
